import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { SustitutoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class SustitutoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getSustitutoService(): Observable<BodyListResponse<SustitutoDTO>> {
    return this.http.get<BodyListResponse<SustitutoDTO>>(API_URL + '/api/v1/sustituto/todos');
  }

  guardarSustitutoService(sustitutoDTO: SustitutoDTO): Observable<SustitutoDTO> {
    return this.http.post<SustitutoDTO>(API_URL + '/api/v1/sustituto', sustitutoDTO);
  }

  getSustitutoPorCodigoSustitutoService(codigoSustituto: string): Observable<BodyResponse<SustitutoDTO>> {
    return this.http.get<BodyResponse<SustitutoDTO>>(API_URL + '/api/v1/sustituto/' + codigoSustituto);
  }

   getSustitutoPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<SustitutoDTO>> {
    return this.http.get<BodyListResponse<SustitutoDTO>>(API_URL + '/api/v1/sustituto/persona/' + codigoPersona);
  }
  
}
